/**
 * 数字人「照片省流版」(longform,ai 走 liveportrait / emo-v1)已永久下架(1019 用户拍板)。
 *
 * 1016 D1 起是总开关藏起,1019 起入口、文案、价签全部删除。这里只剩**老数据兼容**:
 * 老草稿 / 「再来一条」(dhRemake)/ 卡片预填里若还带 `mode=longform`,统一回落生动版(flagship),
 * 表单不会落在一个已不存在的档位上。
 *
 * ★历史展示不走这里:老作品的「照片省流版」标签(works mappers / 任务详情页)与 `DhMode` 类型里的
 *   longform 都保留,老片照常显示。
 */
/** 老数据档位归一:longform(已下架)→ flagship,其余档位原样。 */
export function normalizeDhPhotoMode<M extends string>(
  mode: M
): Exclude<M, "longform"> | "flagship" {
  return (mode === "longform" ? "flagship" : mode) as Exclude<M, "longform"> | "flagship";
}

/** 是否照片线档位(含已下架的 longform 老值)—— 老草稿 / 再来一条据此判断要不要回填档位。 */
export function isDhPhotoMode(mode: string | null | undefined): mode is "flagship" | "longform" {
  return mode === "flagship" || mode === "longform";
}

/**
 * 已下架的档位(1019 起只有照片省流版 longform)。api 对这一档的 create / retry / revoice 一律 400
 * 「照片省流版已下架,请改用生动版」—— 历史任务上的「重试」「换音色」入口据此禁用 / 藏掉并写明原因;
 * 「再来一条」不受影响(走 normalizeDhPhotoMode 回落生动版)。
 */
export function isRetiredDhMode(mode: string | null | undefined): boolean {
  return mode === "longform";
}

/** 历史省流版任务上替代「重试 / 换音色」的说明(短句,卡面与详情页同源)。 */
export const DH_RETIRED_MODE_NOTICE =
  "照片省流版该档已下架,不能重试或换音色;可「再来一条」改用生动版";
